import { ArrowDown, ArrowUp, Columns3, RotateCcw } from "lucide-react";
import Popover from "./Popover";

/* Choix et ordre des colonnes. `visible` est la liste ordonnée des clés
   affichées ; les colonnes `locked` ne peuvent être ni masquées ni déplacées. */
export default function ColumnPicker({ columns = [], visible = [], onChange, onReset }) {
  const shown = visible.map(key => columns.find(c => c.key === key)).filter(Boolean);
  const hidden = columns.filter(c => !visible.includes(c.key));

  const toggle = col => {
    if (col.locked) return;
    onChange(visible.includes(col.key)
      ? visible.filter(k => k !== col.key)
      : [...visible, col.key]);
  };

  const move = (key, delta) => {
    const index = visible.indexOf(key);
    const next = index + delta;
    if (index < 0 || next < 0 || next >= visible.length) return;
    const copy = [...visible];
    copy.splice(next, 0, copy.splice(index, 1)[0]);
    onChange(copy);
  };

  return (
    <Popover label="Colonnes" icon={Columns3} testid="column-picker" title="Colonnes affichées" width={268}>
      <div className="adm-menu-head">
        <span>{shown.length} sur {columns.length}</span>
        <button type="button" className="adm-btn is-sm is-ghost" onClick={onReset} data-testid="column-reset">
          <RotateCcw size={12} />Réinitialiser
        </button>
      </div>
      {shown.map((col, i) => (
        <div key={col.key} className="adm-menu-item" style={{ gap: 6 }}>
          <label className="adm-check" style={{ flex: 1, minWidth: 0 }}>
            <input
              type="checkbox"
              checked
              disabled={col.locked}
              onChange={() => toggle(col)}
              data-testid={`column-toggle-${col.key}`}
            />
            <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{col.header}</span>
          </label>
          <button
            type="button" className="adm-btn is-sm is-ghost is-icon" aria-label={`Monter ${col.header}`}
            disabled={i === 0} onClick={() => move(col.key, -1)}
          >
            <ArrowUp size={12} />
          </button>
          <button
            type="button" className="adm-btn is-sm is-ghost is-icon" aria-label={`Descendre ${col.header}`}
            disabled={i === shown.length - 1} onClick={() => move(col.key, 1)}
          >
            <ArrowDown size={12} />
          </button>
        </div>
      ))}
      {hidden.length > 0 && <div className="adm-menu-sep" />}
      {hidden.map(col => (
        <label key={col.key} className="adm-menu-item" style={{ cursor: "pointer" }}>
          <input
            type="checkbox"
            checked={false}
            onChange={() => toggle(col)}
            style={{ accentColor: "var(--adm-accent)" }}
            data-testid={`column-toggle-${col.key}`}
          />
          <span>{col.header}</span>
        </label>
      ))}
    </Popover>
  );
}
